<template>
    <!-- Top of the editor's page: company logo, and the details block (opens the Details drawer) -->
    <header class="ep-head">
        <img v-if="$store.state.user.logoPath" :src="$store.state.apiUrl + $store.state.spacesUrl + $store.state.user.logoPath" alt="" />
        <button type="button" class="ep-meta" title="Edit details" @click="$emit('open')">
            <div><b>Location:</b> {{ locs.join(', ') || 'None' }}</div>
            <div><b>Department:</b> {{ deps.join(', ') || 'None' }}</div>
            <div v-if="types.length"><b>Type:</b> {{ types.join(', ') }}</div>
            <div><b>Owner:</b> {{ ownerNames || 'None' }}</div>
            <div><b>Version:</b> V{{ version }} (editing)</div>
            <span class="ep-meta-edit">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>Edit details
            </span>
        </button>
    </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'EditorDocHead',
    props: [ 'locs', 'deps', 'types', 'ownerNames', 'version' ],
    emits: [ 'open' ]
});
</script>
